import {
    OnboardingCongratulationsContainerStyled,
    OnboardingCongratulationsPageStyled,
    OnboardingRepeatedCongratulationsContentStyled
} from "./styled/OnboardingCongratulationsPageStyled";
import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import ToAppButton from "../../../components/ToAppButton/ToAppButton";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const OnboardingRepeatedCongratulationsContent = () => {
    const {getLangPath} = useLangContext();
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorialClosePosition'});

    const handleClick = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'BackToTrading'})
    }, [pushGtmEvent]);

    return (
            <OnboardingCongratulationsPageStyled>
                <OnboardingCongratulationsContainerStyled>
                    <OnboardingRepeatedCongratulationsContentStyled>
                        <h1 className="mb-3" dangerouslySetInnerHTML={{__html: getLangPath('onboarding.good_job')}}/>
                        <p dangerouslySetInnerHTML={{__html: getLangPath('onboarding.keep_practicing')}}/>
                    </OnboardingRepeatedCongratulationsContentStyled>
                    <ToAppButton>
                        <Button
                                size="lg"
                                className="mt-2"
                                variant="primary"
                                onClick={handleClick}
                        >
                            {getLangPath('onboarding.back_to_trading')}
                        </Button>
                    </ToAppButton>
                </OnboardingCongratulationsContainerStyled>
            </OnboardingCongratulationsPageStyled>
    )
}